import { useEffect, MutableRefObject, useCallback } from 'react';
import type ReactQuill from 'react-quill';

type TElement = HTMLTextAreaElement | ReactQuill;

type TUseCommentForm = {
  inputRef: MutableRefObject<TElement>;
  scrollPointRef: MutableRefObject<HTMLDivElement>;
  withScroll?: boolean;
  scrollCallback?: VoidFunction;
};

export const useCommentForm = ({ inputRef, scrollPointRef, withScroll, scrollCallback }: TUseCommentForm): void => {
  const handleScroll = useCallback(() => {
    if (scrollPointRef?.current) {
      const topCoordinate = scrollPointRef.current.getBoundingClientRect().top + window.scrollY - 10;
      window.scrollTo({ behavior: 'smooth', top: topCoordinate });
    }
  }, [scrollPointRef]);

  const setCaretToEnd = useCallback((element: TElement) => {
    // Quill editor
    if ('getEditor' in element) {
      const quill = element.getEditor();
      const length = quill.getLength();
      // установка каретки в конце
      quill.setSelection(length, 0);
      return;
    }

    // Textarea
    const length = element.value.length;
    // установка каретки в конце
    element.setSelectionRange(length, length);
  }, []);

  useEffect(() => {
    const el = inputRef?.current;

    if (!withScroll || !el) return;

    handleScroll();

    setTimeout(() => {
      el.focus();
      setCaretToEnd(el);
    }, 100);

    if (scrollCallback) {
      scrollCallback();
    }
  }, [handleScroll, inputRef, scrollCallback, setCaretToEnd, withScroll]);
};
